import { Component } from '@angular/core';
import { LocaleService } from '../../shared/services/locale.service';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-language-selector',
    imports: [MatButton, AsyncPipe, UpperCasePipe],
    templateUrl: './language-selector.component.html',
    styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {

    constructor(private localeService: LocaleService) {
    }

    languageChoices(): string[] {
        return this.localeService.supportedLocales();
    }

    currentLanguage(): string {
        return this.localeService.activeLocale();
    }

    otherChoices(): string[] {
        return this.languageChoices().filter(l => l !== this.currentLanguage());
    }

    changeLocale(locale: string): void {
        this.localeService.changeLocale(locale);
    }
}
